export const SURVEY_LIST_PATH = "/surveys-editor";
